import styled from 'styled-components';
import { AppStyledProps } from '../../../../../types';
import { Props } from './types';

type T = Props & AppStyledProps;

export const RootStyled = styled.div<T>`
  width: 100vw;
  height: 100vh;
  height: 100%;
  background: rgba(0, 0, 0, 1);
  z-index: 1200;
  position: absolute;
  top: 0;
  font-family: WorkSans;

  display: flex;
  flex-direction: column;
  justify-content: start;

  .game-book-no-content {
    padding: 70px 60px 30px 60px;
    font-family: WorkSans;
    font-size: 28px;
    font-weight: 600;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.36;
    letter-spacing: -0.56px;
    text-align: center;
    color: var(--white);
  }
`;
